export default __webpack_public_path__ + "static/crown-c3a4d69d2c8c0d66ce84099b13cf31e6.png";